import system from './api'
import wechat from './wechat'
import user from './user'
import answer from './answer'
import exchange from './exchange'
import address from './address'
import pay from './pay'
import mwap from './mwap'
import family from './wholefamily'
import jobs from './jobs'
import message from './message'
import order from './order'
import classs from './class'
export default {
    system,
    wechat,
    user,
    answer,
    exchange,
    pay,
    address,
    mwap,
    family,
    jobs,
    message,
    order,
    classs
}
